export const REDEEM_CODE_PREFIX = 'RED-';

export const ERRORS_REDEEM = {
  INVALID_REDEEM_CODE: 'invalidRedeemCode',
  USER_ALREADY_REDEEMED_IN_CAMPAIGN: 'oneCodePerAccount',
  HAS_ORDER_PENDING: 'hasOrderPending',
  USER_ALREADY_REDEEMED_CODE: 'userAlreadyRedeemedCode',
};

export const REDEEM_PARAM = 'redeem';

export const TOP_UP_PACKAGE_CODE_REGEX = /STUDIO-TOPUP/;
